import { useAxios } from "../../hooks/useAxios";
import { Pagination } from "../types";
import { Conversation } from "./conversations";

interface ConversationPathParams {
  id: string;
}

type CreateConversationParams = Pick<Conversation, "latencySeconds" | "date" | "startTime" | "endTime" | "mode"> & {
  participantIds: string[];
  latencyDate?: string;
};
type UpdateConversationParams = Partial<Conversation> & {
  _id: string;
  accept?: boolean;
  latencyDate?: string;
};

type ConversationsEndpointConfig = {
  GET_CONVERSATION: EndpointConfig<
    ConversationPathParams,
    Conversation
  >;
  GET_CONVERSATIONS: EndpointConfig<
    Pagination,
    {
      total: number;
      results: Conversation[]
    }
  >;
  GET_ADMIN_CONVERSATIONS: EndpointConfig<
    Pagination,
    {
      total: number;
      results: Conversation[]
    }
  >;
  CREATE_CONVERSATION: EndpointConfig<
    CreateConversationParams,
    Conversation
  >;
  UPDATE_CONVERSATION: EndpointConfig<
    UpdateConversationParams,
    Conversation
  >;

  DELETE_CONVERSATION: EndpointConfig<
    ConversationPathParams,
    null
  >;
  MIGRATE_CONVERSATION_TYPES: EndpointConfig<
    Record<string, never>,
    null
  >;
};

// conversations api specific logic

const requestInitialisers: RequestConfig<ConversationsEndpointConfig> = {
  GET_CONVERSATION: (
    ({ id }) => ({
      url: `/conversation/${id}`,
      method: "GET"
    })
  ),
  GET_CONVERSATIONS: (
    params => ({
      url: "/conversation",
      method: "GET",
      params
    })
  ),
  GET_ADMIN_CONVERSATIONS: (
    params => ({
      url: "/admin/conversation",
      method: "GET",
      params
    })
  ),
  CREATE_CONVERSATION: (
    params => ({
      url: "/conversation",
      method: "POST",
      data: params
    })
  ),
  UPDATE_CONVERSATION: (
    ({ _id, ...params }) => ({
      url: `/conversation/${_id}`,
      method: "PATCH",
      data: params
    })
  ),
  DELETE_CONVERSATION: (
    ({ id }) => ({
      url: `/conversation/${id}`,
      method: "DELETE"
    })
  ),
  MIGRATE_CONVERSATION_TYPES: (
    () => ({
      url: "/conversation/migrate/default-modes",
      method: "POST"
    })
  )
};

export const useConversationsApi: UseApiRequest<ConversationsEndpointConfig> = name => useAxios(requestInitialisers[ name ]);
